import axios from 'axios';
import { baseURL } from '../Constants';

const url = baseURL + "/vdo";

export interface VdoLinkResponse {
    playerName: string;
    steamId: string;
    teamName: string;
    pushLink?: string;
    viewLink: string;
}

export const fetchMyVdoLink = async (): Promise<VdoLinkResponse> => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${url}/my-link`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchPlayerVdoLink = async (steamId: string): Promise<VdoLinkResponse> => {
    try {
        const adminToken = localStorage.getItem("adminToken");
        const token = adminToken || localStorage.getItem("token");
        const response = await axios.get(`${url}/player/${steamId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
